import { render, staticRenderFns } from "./SpecializationEditModal.vue?vue&type=template&id=3ec51eb8&scoped=true"
import script from "./SpecializationEditModal.vue?vue&type=script&lang=js"
export * from "./SpecializationEditModal.vue?vue&type=script&lang=js"
import style0 from "./SpecializationEditModal.vue?vue&type=style&index=0&id=3ec51eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec51eb8",
  null
  
)

export default component.exports